import React from 'react';
import Icon from '../../../components/AppIcon';
import { useService } from '../../../components/context/ServiceContext';

const TimeSlotCard = ({ slot, isSelected, onSelect }) => {
  const getStatusStyles = () => {
    if (slot?.isBooked || slot?.isBlocked) {
      return 'bg-muted text-muted-foreground cursor-not-allowed opacity-60';
    }
    if (isSelected) {
      return 'bg-gradient-to-br from-primary to-secondary text-primary-foreground shadow-lg scale-105';
    }
    return 'bg-card text-foreground border-2 border-border hover:border-primary hover:shadow-md hover:scale-102';
  };

  const { selectedServices } = useService();
  const serviceItem = selectedServices?.map(s => s?.name) || [];

  const handleClick = () => {
    if (!slot?.isBooked && !slot?.isBlocked) {
      onSelect(slot);
    }
  };

  // Keep the original structure you wanted
  const GetSlotAvailability = ({ slotServices = [], selectedServices = [] }) => {
    const hasServices = slotServices.length > 0;
    const allSelectedMatch = selectedServices.every(s => slotServices.includes(s));

    let text = '';
    let type = '';

    if (!hasServices || allSelectedMatch) {
      text = 'Available';
      type = 'success';
    } else {
      text = `Reserved for ${slotServices.join(', ')}`;
      type = 'warning';
    }

    const colorClass = type === 'success' ? 'text-success' : 'text-warning';
    const iconName = type === 'success' ? 'Check' : 'X';

    return (
      <div className={`flex items-center gap-1 text-xs font-caption mt-1 ${colorClass}`}>
        <Icon name={iconName} size={14} />
        <span>{text}</span>
      </div>
    );
  };

  return (
    <button
      onClick={handleClick}
      disabled={slot?.isBooked || slot?.isBlocked}
      className={`w-full p-4 md:p-5 lg:p-6 rounded-xl transition-all duration-250 ease-elegant ${getStatusStyles()}`}
      aria-label={`${slot?.time} - ${
        slot?.isBooked ? 'Booked' : slot?.isBlocked ? 'Blocked' : 'Available'
      }`}
      aria-pressed={isSelected}
    >
      <div className="flex flex-col items-center gap-2 md:gap-3">
        <div className="flex items-center gap-2">
          <Icon
            name="Clock"
            size={20}
            color={
              slot?.isBooked || slot?.isBlocked
                ? 'var(--color-muted-foreground)'
                : isSelected
                ? 'var(--color-primary-foreground)'
                : 'var(--color-primary)'
            }
          />
          <span className="font-heading font-semibold text-lg md:text-xl lg:text-2xl">
            {slot?.time}
          </span>
        </div>

        <div className="flex items-center gap-2 text-xs md:text-sm font-caption">
          <Icon
            name="Timer"
            size={16}
            color={
              slot?.isBooked || slot?.isBlocked
                ? 'var(--color-muted-foreground)'
                : isSelected
                ? 'var(--color-primary-foreground)'
                : 'currentColor'
            }
          />
          <span>{slot?.duration} min</span>
        </div>

        {slot?.isBooked && (
          <div className="flex items-center gap-1 text-xs font-caption mt-1">
            <Icon name="X" size={14} />
            <span>Booked</span>
          </div>
        )}

        {slot?.isBlocked && (
          <div className="flex items-center gap-1 text-xs font-caption mt-1">
            <Icon name="X" size={14} />
            <span>Blocked</span>
          </div>
        )}

        {!slot?.isBooked && !slot?.isBlocked && !isSelected && (
          <GetSlotAvailability
            slotServices={slot?.services}
            selectedServices={serviceItem}
          />
        )}

        {isSelected && (
          <div className="flex items-center gap-1 text-xs font-caption mt-1">
            <Icon name="CheckCircle2" size={14} />
            <span>Selected</span>
          </div>
        )}
      </div>
    </button>
  );
};

export default TimeSlotCard;